var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Willkommen im Meldesystem")]),_c('br'),_c('small',[_vm._v("Version: "+_vm._s(_vm.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }